module.exports = __webpack_public_path__ + "img/mx.b9fb2f9e.svg";